import React from "react";
const DropboxPreviewIcon = React.forwardRef((props, svgRef) => (
  <svg
    width="210px"
    height="210px"
    viewBox="0 0 210 210"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    ref={svgRef}
    {...props}
  >
    <title>dropbox_preview_placeholder</title>
    <g
      id="Header"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="dropbox_preview_placeholder">
        <circle
          id="background"
          fill="#7A8FE7"
          fillRule="nonzero"
          cx="105"
          cy="105"
          r="105"
        ></circle>
        <g
          id="document"
          transform="translate(67.000000, 56.000000)"
        >
          <path
            d="M76,11.75 L76,86.9591914 C76,88.6385836 74.6569598,90 72.9903842,90 L7.00961584,90 C5.34745091,90 4,88.6491454 4,86.9644752 L4,3.03552479 C4,1.35905074 5.34331243,0 7.00235843,0 L40,0 L63,0 L76,11.75 Z"
            id="shadow"
            fillOpacity="0.18"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M72,15.75 L72,90.9591914 C72,92.6385836 70.6569598,94 68.9903842,94 L3.00961584,94 C1.34745091,94 0,92.6491454 0,90.9644752 L0,7.03552479 C0,5.35905074 1.34331243,4 3.00235843,4 L36,4 L59,4 L72,15.75 Z"
            id="paper"
            fill="#FFFFFF"
          ></path>
          <path
            d="M57,6 L57,17.75 L70,17.75 L70,90.9591914 C70,91.2492685 69.88607,91.5131244 69.6975907,91.7035573 C69.5168607,91.8861604 69.2672948,92 68.9903842,92 L68.9903842,92 L3.00961584,92 C2.7322603,92 2.48131522,91.8869546 2.2997666,91.703843 C2.11265704,91.5151227 2,91.2532906 2,90.9644752 L2,90.9644752 L2,7.03552479 C2,6.74697939 2.11385587,6.48471746 2.30121585,6.29528776 C2.48060176,6.11392021 2.72796552,6 3.00235843,6 L3.00235843,6 L57,6 Z"
            id="border"
            stroke="#292929"
            strokeWidth="4"
          ></path>
          <path
            d="M36.0921347,37.008575 L43.8395503,43.27443 L47.1483001,41.1718809 L47.1483001,43.5341391 L36.0921347,50 L25.0157199,43.5341391 L25.0157199,41.1718809 L28.3447192,43.27443 L36.0921347,37.008575 Z M24.6654055,29.0123211 L35.8035809,35.71799 L28.0764148,41.983845 L17,34.8970704 L24.6654055,29.0123211 Z M47.3548439,29.0123211 L55,34.9776698 L43.964084,41.983845 L36.2369178,35.71799 L47.3548439,29.0123211 Z M28.0764148,16 L35.8035809,22.265855 L24.6654055,28.9715239 L17,22.9454769 L28.0764148,16 Z M43.964084,16 L55,23.0061752 L47.3548439,28.9715239 L36.2369178,22.265855 L43.964084,16 Z"
            id="dropbox"
            fill="#007EE5"
          ></path>
          <path
            d="M20,73 L20,85 L8,85 L8,73 L20,73 Z M64,73 L64,85 L23,85 L23,73 L64,73 Z M20,57 L20,69 L8,69 L8,57 L20,57 Z M64,57 L64,69 L23,69 L23,57 L64,57 Z"
            id="text"
            fill="#F5F5F5"
            fillRule="nonzero"
          ></path>
        </g>
        <g
          id="lock"
          transform="translate(122.000000, 129.000000)"
        >
          <rect
            id="lock-background"
            stroke="#292929"
            strokeWidth="4"
            fill="#FFFFFF"
            x="2"
            y="2"
            width="29"
            height="29"
            rx="4"
          ></rect>
          <path
            d="M17.5472731,7 C19.9150508,7 21.8415542,8.89136383 21.8415542,11.2159532 L21.8415542,11.2159532 L21.8415542,12.4760871 C21.8415542,12.8776203 21.5101542,13.2029756 21.1011609,13.2029756 C20.6924638,13.2029756 20.3607676,12.8776203 20.3607676,12.4760871 L20.3607676,12.4760871 L20.3607676,11.2159532 C20.3607676,9.69297645 19.0988413,8.45377696 17.5472731,8.45377696 L17.5472731,8.45377696 L16.0664865,8.45377696 C14.5152145,8.45377696 13.252992,9.69297645 13.252992,11.2159532 L13.252992,11.2159532 L13.252992,14.7050179 L22.8736625,14.7050179 C23.2826557,14.7050179 23.6140558,15.0303732 23.6140558,15.4319064 L23.6140558,15.4319064 L23.6140558,25.5993317 C23.6140558,26.0008649 23.2826557,26.3262202 22.8736625,26.3262202 L22.8736625,26.3262202 L10.7403933,26.3262202 C10.3314,26.3262202 10,26.0008649 10,25.5993317 L10,25.5993317 L10,15.4319064 C10,15.0303732 10.3314,14.7050179 10.7403933,14.7050179 L10.7403933,14.7050179 L11.7722054,14.7050179 L11.7722054,11.2159532 C11.7722054,8.89136383 13.6987087,7 16.0664865,7 L16.0664865,7 Z M22.1332692,16.1587949 L11.4807866,16.1587949 L11.4807866,24.8724432 L22.1332692,24.8724432 L22.1332692,16.1587949 Z M19.0774119,18.2907818 C19.3229263,17.9694971 19.7870048,17.9046586 20.1139625,18.1454041 C20.4412163,18.3861496 20.5075556,18.8417632 20.2620412,19.1630479 L20.2620412,19.1630479 L16.856232,23.6212004 C16.7191112,23.8008872 16.5049894,23.9078852 16.276356,23.9119558 L16.276356,23.9119558 L16.2639174,23.9119558 C16.0397263,23.9119558 15.8276776,23.8122267 15.6870029,23.6403903 L15.6870029,23.6403903 L13.6633599,21.1689694 C13.4071839,20.8561166 13.4578268,20.3987584 13.7764921,20.1469642 C14.0951573,19.8954608 14.5613089,19.94518 14.8171889,20.2580328 L14.8171889,20.2580328 L16.2437787,21.9999483 Z"
            fill="#000000"
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </g>
  </svg>
));
DropboxPreviewIcon.displayName = "DropboxPreviewIcon";
export default DropboxPreviewIcon;
